export const BACKGROUND_COLOR = '#f5f2ec';
export const WEDGE_STROKE = '#0e2232';
export const STROKE_COLOR = '#132b3a';
export const BLOOM_DURATION = 420; // ms
export const MAX_STROKES = 5;
export const JITTER_STRENGTH = 0.02; // percent of radius
export const INK_DRIFT_STRENGTH = 0.015; // relative to radius
export const SAVE_LIMIT = 12;

export const foldPresets = [
  { id: '6', value: 6, labelKey: 'folds.six' },
  { id: '8', value: 8, labelKey: 'folds.eight' },
  { id: '12', value: 12, labelKey: 'folds.twelve' },
];
